import React, { Component } from 'react';
import { Route, Redirect, BrowserRouter } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import Loadable from 'react-loadable';

import HeaderContainer from '../header/HeaderContainer';

import styles from './Style';

const Loading = () => (
  <div className={styles.spiner}>
    <FontAwesomeIcon icon={faCircleNotch} size="3x" spin={true} />
  </div>
);

const MainContainer = Loadable({
  loader: () => import(/* webpackChunkName: "Main" */ '../main/MainContainer'),
  loading: Loading
});

const MatterportContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Matterport" */ '../matterport/MatterportContainer'),
  loading: Loading
});

const GalleryContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Gallery" */ '../gallery/GalleryContainer'),
  loading: Loading
});

const MapContainer = Loadable({
  loader: () => import(/* webpackChunkName: "Map" */ '../map/MapContainer'),
  loading: Loading
});

const VideoContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Video" */ '../video/VideoContainer'),
  loading: Loading
});

const FloorplanContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Floorplan" */ '../floorplan/FloorplanContainer'),
  loading: Loading
});

const ThreeDModelContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ThreeDModel" */ '../threeDModel/ThreeDModelContainer'),
  loading: Loading
});

const AboutContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "About" */ '../about/AboutContainer'),
  loading: Loading
});

const WalkthruContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Walkthru" */ '../walkthru/WalkthruContainer'),
  loading: Loading
});

const PresentedContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Presented" */ '../presented/PresentedContainer'),
  loading: Loading
});

const PresentedFullscreenContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PresentedFullscreen" */ '../presented/PresentedFullscreenContainer'),
  loading: Loading
});

const ListingsContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Listings" */ '../listings/ListingsContainer'),
  loading: Loading
});

const NotFoundContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "NotFound" */ '../notFound/NotFoundContainer'),
  loading: Loading
});

const NotProducedComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: "NotProduced" */ '../notFound/NotProducedComponent'),
  loading: Loading
});

const CanceledComponent = Loadable({
  loader: () =>
      import(/* webpackChunkName: "NotProduced" */ '../notFound/CanceledContainer'),
  loading: Loading
});

class AppComponent extends Component {
  render() {
    return (
      <div
        className={styles.app}
        style={
          this.props.blurValue > 0
            ? { filter: `blur(${this.props.blurValue}px)` }
            : {}
        }
      >
        {!this.props.errorPage() ? <HeaderContainer /> : null}
        <main
          style={this.props.errorPage() ? {height: '100%'} : {}}
          className={
            this.props.home ? styles.mainWrapperDashboard : styles.mainWrapper
          }
        >
          <AnimatedSwitch
            atEnter={{ opacity: .1 }}
            atLeave={{ opacity: 0 }}
            atActive={{ opacity: 1 }}
            className={styles.switchWrapper}
          >
            <Route
              exact
              path="/:tourId(\d+)/:tourType(r|u|b|)?"
              component={MainContainer}
            />
            <Route
              path="/:tourId(\d+)?/:tourType(r|u|b|)?/gallery"
              component={GalleryContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/map"
              component={MapContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/video/:order(\d+)"
              component={VideoContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/matterport/:order(\d+)"
              component={MatterportContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/floorplan"
              component={FloorplanContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/3d"
              component={ThreeDModelContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/about"
              component={AboutContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/walkthru"
              component={WalkthruContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/presented"
              component={PresentedContainer}
            />
            <Route
              path='/:tourId(\d+)/:tourType(r|u|b)/:agentType(contactagent|contactcolister)'
              component={PresentedFullscreenContainer}
            />
            <Route
              path="/:tourId(\d+)/:tourType(r|u|b|)?/listings"
              component={ListingsContainer}
            />
            <Route path="/notProduced" component={NotProducedComponent} />
            <Route path="/notFound" component={NotFoundContainer} />
            <Route path="/canceled" component={CanceledComponent} />
            <Redirect to="/notFound" />
          </AnimatedSwitch>
          {this.props.children}
        </main>
      </div>
    );
  }
}

export default AppComponent;
